export default {
    address: {
        city: "Stad",
        city_locality: "Stad \/ Ort",
        country: "Land",
        line1: "Adressrad 1",
        line2: "Adressrad 2",
        postal_code: "Postnummer",
        state: "Ange",
        state_region: "Delstat\/region"
    },
    alerts: {
        account_2fa: "Säkra ditt konto med tvåfaktorsautentisering.",
        account_2fa_success: "Tvåfaktorsautentisering är aktiverad.",
        activate_instruction: "Om du aktiverar automatisk recensionsinsamling kommer systemet att försöka begära en recension från {count}. Visa dina mallar innan du aktiverar.",
        activate_intro: "Begär kontinuerligt recensioner baserat på din strategi.",
        agency_mcp_server: "Anslut Claude eller valfri MCP klient till din byrås MCP server. Auktoriserade assistenter kan hantera din byrås projekt, kunder och team åt dig.",
        agency_sso: "Anslut en OpenID Connect-identitetsleverantör för klientinloggning.",
        ai_assistant: "Ditt företagsnamn och beskrivning krävs för att använda AI för recensionsförslag och svar.",
        api_key_roll: "Är du säker på att du vill ändra din API nyckel? Detta kommer att påverka alla program som använder den.",
        ask_confirm: "Är du säker på att du vill begära recensioner från {count}? Detta kommer att schemalägga förfrågningar för alla kunder som inte har blivit tillfrågade ännu.",
        cname_delete: "Är du säker på att du vill ta bort CNAME: {cname_name}?",
        cname_not_configured: "Den här posten har ännu inte konfigurerats. Vänta...",
        cname_warning: "Meddelanden som redan har skickats till dina kunder kommer att ha brutna länkar.",
        connection_disabled: "Anslutningen är inaktiverad. Vänligen återanslut.",
        customer_archive: "Är du säker på att du vill arkivera kunden: {customer_name}? Ej skickade meddelanden kommer att avbrytas.",
        customer_cancel: "Är du säker på att du vill avbryta alla osända meddelanden för kunden: {customer_name}?",
        customer_ingest: "Inkludera den här e-postadressen i fältet BCC när du skickar e-postmeddelanden till dina kunder för att få deras namn och e-postadress importerade automatiskt.",
        customer_resubscribe: "Är du säker på att du vill återprenumerera kunden: {customer_name}?",
        customer_unarchive: "Är du säker på att du vill avarkivera kunden: {customer_name}?",
        customer_unsubscribe: "Är du säker på att du vill avsluta prenumerationen på kunden: {customer_name}?",
        customer_unsubscribe_all: "Är du säker på att du vill avsluta prenumerationen för {count} så att de inte längre får meddelanden från det här projektet?",
        delete: "Är du säker på att du vill ta bort {model}: {name}?",
        delete_count: "Är du säker på att du vill ta bort {count}",
        domain_agency: "Lägg till din egen sändningsdomän för att helt vitmärka din byrå.",
        domain_delete: "Är du säker på att du vill ta bort domänen: {name}? Vi kommer att fortsätta att skicka e-postmeddelanden från vårt eget domännamn.",
        domain_dmarc: "Lägg till en DMARC post till din domän för att minska risken för att e-postmeddelanden hamnar i skräpposten.",
        domain_project: "Lägg till en sändande domän så att vi kan skicka e-postmeddelanden till dina kunder från ditt eget domännamn.",
        export_confirm: "Är du säker på att du vill exportera alla dina {model}?",
        export_count: "Är du säker på att du vill exportera {count}?",
        export_link: "En nedladdningslänk kommer att skickas till {email} kort efter att du gjort begäran.",
        highlights_save_disabled: "Du kan valfritt ta bort höjdpunkter från alla recensioner som för närvarande innehåller dem.",
        highlights_save_enabled: "För att generera markeringar för alla positiva recensioner, markera rutan nedan. Om du bara ändrar markeringsfärgen, lämna rutan omarkerad.",
        integration_disconnect: "Är du säker på att du vill koppla från {integration_name}?",
        integration_sync: "Är du säker på att du vill synkronisera ditt {integration_name}-konto? Vi importerar kontinuerligt din data åt dig.",
        intro: "Redo att få fler bra recensioner från dina kunder? Importera dina kunder för att komma igång. Begär sedan recensioner manuellt eller tryck på knappen Automatisera och låt recensioner strömma in.",
        logout: "Är du säker på att du vill logga ut?",
        mcp_server: "Anslut Claude eller någon MCP klient till det här projektet. MCP server låter AI-assistenter läsa och hantera recensioner, kunder och meddelanden åt dig.",
        member_confirm: "Är du säker på att du vill ta bort dig själv? Du kommer att förlora åtkomst till det här projektet.",
        member_confirm_all: "Är du säker på att du vill ta bort dig själv? Du kommer att förlora åtkomst till alla dina projekt.",
        member_other_confirm: "Är du säker på att du vill ta bort {noun}: {name}? De kommer att förlora tillgången till detta projekt.",
        member_other_confirm_all: "Är du säker på att du vill ta bort {noun} {name}? De kommer att förlora tillgången till alla sina projekt.",
        message_cancel: "Är du säker på att du vill avbryta det här meddelandet?",
        message_cancel_all: "Är du säker på att du vill avbryta {count}? Denna åtgärd kan endast utföras på osända meddelanden.",
        message_delete: "Är du säker på att du vill ta bort det här meddelandet?",
        oauth_client_revoke: "Är du säker på att du vill återkalla åtkomst för {client}? Alla aktiva sessioner kommer att kopplas bort omedelbart.",
        project_summary: "Det går inte att skapa en sammanfattning just nu.",
        project_suspend: "Är du säker på att du vill suspendera projektet: {project_name}?",
        project_unsuspend: "Är du säker på att du vill avsluta avstängningen av projektet: {project_name}?",
        review_delete: "Är du säker på att du vill ta bort den här recensionen? Denna åtgärd kan inte ångras.",
        review_page_confirm: "Är du säker på att du vill spara dina ändringar?",
        review_page_default: "Är du säker på att du vill göra recensionssidan: {name} till din standardsida? Den här sidan kommer att användas om ingen annan sida tilldelas en recensionsförfrågan.",
        review_page_delete: "Är du säker på att du vill ta bort recensionssidan: {name}? Alla kunder som för närvarande dirigeras till den här sidan kommer att dirigeras till din standardsida.",
        review_page_delete_all: "Är du säker på att du vill ta bort {count}? Din standardsida för recension kommer inte att raderas.",
        review_page_fields: "Använd fält för att fånga kundinformation när du lämnar en recension. Lägg till fler fält i ditt formulär och visa dem villkorligt när kunder väljer ett betyg.",
        review_page_instructions: "Visa instruktioner direkt ovanför formuläret efter att ett betyg har valts.",
        review_page_location_picker: "Låt kunderna välja vilken plats som helst i ditt projekt för recensionen. Detta kommer att vara förvalt om recensionssidan är avsedd att visas för en specifik plats.",
        review_page_locations: "Välj de platser som ska använda denna recensionssida. En plats kan endast tilldelas en recensionssida. Om en plats inte tilldelas en, används standardsidan för recensioner.",
        review_page_redirects: "Hoppa över formuläret efter att ett betyg har valts och omdirigera någon annanstans. Du kan också dela upp trafiken till flera webbplatser genom att lägga till mer än en omdirigering för varje betyg.",
        share_template_delete: "Är du säker på att du vill ta bort delningsmallen \"{name}\"? Detta kan inte ångras.",
        smtp_remove: "Är du säker på att du vill ta bort SMTP -konfigurationen från ditt projekt? Din sändande domän kommer att falla tillbaka till standardkonfigurationen.",
        smtp_setup: "Skicka e-post från din egen e-postserver. Ange dina SMTP inloggningsuppgifter. Om din server använder IP-begränsningar, vänligen vitlista följande IP-adresser som används av vårt system: {ips}.",
        space_delete: "Är du säker på att du vill ta bort arbetsyta: {name}? Alla projekt inuti det kommer att tas bort.",
        tag_rule: "Lägg till en positiv term och dess negativa motsvarighet. Om det gäller kommer vi att använda AI för att automatiskt tagga recensionen med den ena eller den andra.",
        user_delete: "Är du säker på att du vill ta bort användarkontot för: {email}?",
        user_verify: "För att verifiera din e-postadress och aktivera ditt konto, klicka på länken i e-postmeddelandet som skickas till: {email}.",
        widget_delete: "Är du säker på att du vill ta bort widgeten: {name}? Widgeten kommer inte längre att visas på några webbplatser.",
        widget_restore: "Är du säker på att du vill återställa inställningarna för widget: {name}? Endast designen kommer att återgå till standardvärdena.",
        widgets_1: "Lägg till det här skriptet i body-elementet på din webbplats.",
        widgets_2: "Recensionsväggen visar alla dina recensioner som ett rutnät. Lägg till det här skriptet där du vill att widgeten ska visas.",
        widgets_3: "Utvald recension visar en stor recension. Lägg till det här skriptet där du vill att widgeten ska visas."
    },
    billing_statuses: {
        active: "Din prenumeration är aktiv.",
        canceled: "Din prenumeration har avslutats. Uppgradera för att fortsätta.",
        ending: "Din prenumeration slutar den {date}.",
        trial: "Din kostnadsfria provperiod slutar {date}.",
        trial_expired: "Din kostnadsfria provperiod har slutat. Uppgradera för att fortsätta.",
        trial_expiring: "Din kostnadsfria provperiod slutar snart. Uppgradera för att fortsätta."
    },
    brands: {
        boost_space: "Boost.space",
        discord: "Discord",
        email: "E-post",
        facebook: "Facebook",
        google: "Google",
        google_analytics: "Google Analytics",
        hubspot: "HubSpot",
        linkedin: "LinkedIn",
        make_com: "Make.com",
        messenger: "Messenger",
        pabbly: "Pabbly",
        recaptcha: "reCAPTCHA",
        reddit: "Reddit",
        slack: "Slack",
        stripe: "Stripe",
        threads: "Threads",
        twilio: "Twilio",
        whatsapp: "WhatsApp",
        x: "X",
        zapier: "Zapier"
    },
    captions: {
        add_sending_domain: "Lägg till en avsändardomän för att redigera din e-postadress:",
        agency_robots: "Tillåt sökmotorer att indexera din kundportal.",
        ai_business_description: "En detaljerad beskrivning av ditt företag för att hjälpa dig att generera recensionsförslag och svar.",
        ai_business_name: "Namnet på ditt företag.",
        ask_location: "Platsen att tilldela recensionen.",
        ask_review_page: "Sidan för att fånga recensionen.",
        assign_tags: "Tilldela taggar till recensionen.",
        csv_max_rows: "Upp till {count} rader",
        dashboard_configure_settings: "Konfigurera dina projektinställningar.",
        dashboard_import_customers: "Importera dina kunder.",
        dashboard_preview_email_templates: "Förhandsgranska dina e-postmallar.",
        dashboard_preview_kiosk_page: "Förhandsgranska din kiosksida.",
        dashboard_preview_review_page: "Förhandsgranska din recensionssida.",
        dashboard_preview_showcase_page: "Förhandsgranska din utställningssida.",
        logo_height: "Höjden på logotypen på mejl och sidor.",
        meta_description: "Åsidosätt sidbeskrivningen.",
        meta_title: "Åsidosätt sidtiteln.",
        mfa_password: "Ange ditt kontolösenord.",
        mfa_qr_code: "Skanna QR-koden med din autentiseringsapp.",
        mfa_security_code: "Ange koden från din autentiseringsapp.",
        override_ambassador: "Visa ett märke i dina kunders e-postmeddelanden, sidor och widgetar.",
        project_name: "Namnet på ditt företag, varumärke eller webbplats.",
        project_robots: "Tillåt sökmotorer att indexera dina recensionssidor och visa upp dem.",
        setup_basics: "Bestäm när och hur du ber kunder om omdömen.",
        setup_business: "Berätta vilket namn kunderna känner dig under.",
        setup_google: "Skicka kunder till din Google profil, svara på recensioner och importera befintliga. Du kan hoppa över detta och göra det senare.",
        setup_location_limit: "Din provperiod inkluderar 1 plats. Uppgradera när som helst för att synkronisera mer.",
        project_slug: "Används i kundvända e-postmeddelanden och länkar om en CNAME inte är konfigurerad.",
        review_page_copied_message: "Visas efter att en positiv recension har lämnats in.",
        review_page_email_address: "Få recensioner till denna e-postadress.",
        review_page_link_reveal_position: "Var man kan avslöja länkarna.",
        review_page_link_revealer_label: "Etiketten för att avslöja länkarna.",
        review_page_link_revealer_rating: "Visa länkar om kunden väljer detta betyg eller högre, annars visa en knapp för att avslöja dem.",
        review_page_native_reviews: "Tillåt recensioner på den här plattformen.",
        review_page_rating_selection: "Spara betyg innan en recension skickas.",
        review_page_success_button_link: "Om tom är länken som standard till din projektwebbplats, annars sidans domän.",
        review_page_warning: "Om du hindrar kunder från att lämna offentliga recensioner kan dina företagsuppgifter tas bort.",
        review_reply_status: "Vi kan inte svara offentligt på den här recensionen. Du kan kontakta recensenten direkt istället.",
        review_suggestions: "Hjälp kunder att skriva recensioner.",
        separate_with_commas: "Separera flera med kommatecken.",
        showcase_locations: "Begränsa utställningen till specifika platser.",
        showcase_review_length: "Recensioner måste bestå av minst så många tecken.",
        showcase_since: "Visa recensioner skapade på eller före detta datum.",
        showcase_sources: "Begränsa presentationen till specifika källor.",
        showcase_tags: "Begränsa presentationen till recensioner med specifika tags.",
        signature_html: "Kopiera och klistra in signatur i ditt e-postprogram.",
        signed_up: "Kundens startdatum.",
        twilio_webhook: "Ställ in som URL för återuppringning för din meddelandetjänst.",
        widget_embed: "ID -attributet för div-behållaren där widgeten ska visas."
    },
    labels: {
        accept_all: "Acceptera alla",
        access_code: "Åtkomstkod",
        access_codes: "Åtkomstkoder",
        account: "Konto",
        account_sid: "Konto SID",
        action: "Åtgärd",
        actions: "Åtgärder",
        activate: "Aktivera",
        active: "Aktiv",
        active_subscription: "Aktivt abonnemang",
        add: "Lägg till",
        add_agency_project: "Lägg till ett byråprojekt",
        add_confirmation_message: "Lägg till ett bekräftelsemeddelande.",
        add_css_rules: "Lägg till dina egna css-regler.",
        add_custom_field: "Lägg till anpassat fält",
        add_customer: "Lägg till en kund",
        add_customers_with: "Lägg till kunder med {model}",
        add_external_link: "Lägg till en extern Länk",
        add_external_links: "Lägg till externa Länkar",
        add_introduction: "Lägg till en introduktion.",
        add_js_tags: "Lägg till dina egna JavaScript taggar.",
        add_legal_information: "Lägg till juridisk information.",
        add_location: "Lägg till en plats",
        add_project: "Lägg till ett projekt",
        add_review: "Lägg till en Recension",
        add_source: "Lägg till en källa",
        add_tag: "Lägg till en Tag",
        added: "Tillagd",
        address: "Adress",
        advanced_review_pages: "Avancerade Recensionssidor",
        affiliates: "Affiliates",
        age_of_reviews: "Recensioner tidsålder",
        agency: "Byrå",
        agency_name: "Byråns namn",
        agency_project: "Byråprojekt",
        agency_projects: "Byråprojekt",
        ai: "AI",
        ai_answers: "AI-svar",
        ai_assistant: "AI-assistent",
        ai_auto_tagging: "AI automatisk taggning",
        ai_reviews_and_replies: "Förslag och svar på AI-Recensionar",
        ai_tagging_instructions: "Exempel: Använd på recensioner som nämner väntetider, långsam service eller förseningar.",
        all: "Alla",
        allowed_domains: "Tillåtna domäner",
        amount: "Belopp",
        analytics: "Analys",
        and: "och",
        anonymous_reviews: "Anonyma Recensioner",
        answer: "Svar",
        any: "Några",
        api: "API",
        api_key: "API -nyckel",
        appearance: "Utseende",
        approved: "Godkänd",
        archive: "Arkiv",
        archive_customer: "Arkivkund",
        archived: "Arkiverad",
        at_least: "åtminstone",
        at_least_days: "Minst {num} dagar",
        at_least_hours: "Minst {num} timmar",
        at_least_months: "Minst {num} månader",
        at_most: "högst",
        at_most_days: "Högst {num} dagar",
        at_most_hours: "Högst {num} timmar",
        at_most_months: "Högst {num} månader",
        auth_token: "Auth Token",
        authorize: "Godkänna",
        auto_detect: "Automatisk upptäckt",
        auto_tags: "Autotaggar",
        automate: "Automatisera",
        automate_highlights: "Automatisera markeringar",
        automate_replies: "Automatisera svar",
        automatic_review_collection: "Automatisk recensionsinsamling",
        automatically_apply_tags: "Tillämpa tag automatiskt på befintliga recensioner",
        automating: "Automatisering",
        avatar: "Avatar",
        avatars: "Avatarer",
        average_charge: "Genomsnittlig avgift",
        average_review: "Genomsnittlig Recension",
        background_color: "Bakgrundsfärg",
        background_image: "Bakgrundsbild",
        back: "Tillbaka",
        bcc: "BCC",
        bcc_email_address: "BCC e-postadress",
        best_to_worst: "Bäst till sämst",
        billing: "Fakturering",
        blog: "Blogg",
        body: "Brödtext",
        body_font_size: "Teckenstorlek för Brödtext",
        bold: "Fetbold",
        bottom: "Botten",
        bottom_left: "Nederst till vänster",
        bottom_right: "Nederst till höger",
        build_on: "Bygg vidare på {model}",
        business: "Business",
        business_description: "Verksamhetsbeskrivning",
        business_email: "Supportens e-postadress",
        business_name: "Företagsnamn",
        business_phone: "Supporttelefonnummer",
        business_website: "Företagswebbplats",
        button: "Knapp",
        button_label: "Etikett för Knapp",
        button_link: "Länk för Knapp",
        button_position: "Knapp position",
        button_size: "Knapp storlek",
        buy_me_a_coffee: "Bjud mig på en kaffe",
        by: "av",
        by_signing_up: "Genom att skapa ett konto godkänner du våra",
        call_to_action: "Uppmaning till handling",
        cancel: "Avbryt",
        cancel_1_message: "Avbryt 1 meddelande",
        cancel_message: "Avbryt meddelande",
        cancel_messages: "Avbryt {count} Meddelanden",
        cancel_subscription: "Avsluta prenumeration",
        cancel_unsent_messages: "Avbryt osända meddelanden",
        canceled: "Avbruten",
        center: "Centrum",
        change: "Ändra",
        change_key: "Ändra din API nyckel",
        change_plan: "Ändra plan",
        changelog: "Ändringslogg",
        channel: "Kanal",
        channels: "Kanaler",
        characters: "Tecken",
        charges_avg: "Den genomsnittliga avgiften måste vara minst",
        charges_count: "Antalet debiteringar måste vara minst",
        charges_sum: "De totala avgifterna måste vara minst",
        chat_with_us: "Chatta med oss",
        checkbox: "Kryssruta",
        claude: "Claude",
        clear: "Rensa",
        clear_highlights_from_reviews: "Ta bort markeringar från alla recensioner",
        clicked: "Klickade",
        client: "Klient",
        client_id: "Client ID",
        clients: "Klienter",
        close: "Nära",
        cloudflare_warning: "Om du använder Cloudflare måste din proxy vara avstängd.",
        cname: "CNAME",
        cname_setup_incomplete: "Installationen är ofullständig – kommer att tas bort den {date}",
        cname_ssl_pending: "Väntar på SSL-certifikat",
        cname_status_for: "CNAME status för",
        code_editor: "Kodredigerare",
        collapse: "Fäll ihop",
        collect_reviews_anywhere: "Samla recensioner var som helst",
        color: "Färg",
        colors: "Färger",
        commission_rate: "Provisionssats",
        commission_status_approved: "Godkänd",
        commission_status_paid: "Betald",
        commission_status_pending: "I avvaktan på",
        commission_status_reversed: "Omvänd",
        community: "Gemenskap",
        company: "Företag",
        complained: "Klagade",
        confirm_new_password: "Bekräfta nytt lösenord",
        confirmation_message: "Bekräftelsemeddelande",
        connect: "Ansluta",
        connect_bank: "Anslut bankkonto",
        connect_google: "Anslut Google",
        connect_google_business_profile: "Connect Google Business Profile",
        connected: "Ansluten",
        consent_preferences: "Samtyckesinställningar",
        contact_customer: "Kontakta kund",
        contact_support: "Vänligen kontakta supporten.",
        contact_us: "Kontakta oss",
        container_element: "Behållarelement",
        context: "Sammanhang",
        continue: "Fortsätta",
        continue_with_google: "Fortsätt med Google",
        cookie_category_analytics: "Analys",
        cookie_category_essential: "Grundläggande",
        cookie_category_functional: "Funktionell",
        cookie_category_marketing: "Marknadsföring",
        cookie_consent_banner: "Banner för samtycke till cookies",
        cookie_consent_scope_all: "Visa för alla",
        cookie_consent_scope_eea: "Visa endast för besökare i EES och Storbritannien",
        cookie_consent_scope_none: "Visa inte",
        cookie_policy: "Cookiepolicy",
        cookie_preference: "Cookie-preferens",
        copied: "Kopierade",
        copied_message: "Kopierat meddelande",
        copy: "Kopiera",
        copy_embed_code: "Kopiera inbäddningskod",
        copy_signature: "Kopiera Signatur",
        copy_source_code: "Kopiera källkod",
        copy_uuid: "Kopiera UUID",
        create: "Skapa",
        create_account: "Skapa konto",
        create_agency: "Skapa en byrå",
        create_cname: "Skapa en CNAME post och peka på den",
        create_external_link: "Skapa en extern Länk",
        create_field: "Skapa ett fält",
        create_link: "Skapa en Länk",
        create_location: "Skapa en plats",
        create_project: "Skapa ett projekt",
        create_qr_code: "Skapa QR-kod",
        create_review: "Skapa en Recension",
        create_review_page: "Skapa en Recensionssida",
        create_signature: "Skapa en signatur",
        create_source: "Skapa en källa",
        create_space: "Skapa en arbetsyta",
        create_tag: "Skapa en Tag",
        create_tag_rule: "Skapa en taggregel",
        create_webhook: "Skapa en webhook",
        create_widget: "Skapa en widget",
        crms: "CRMs",
        csv: "CSV",
        currency: "Valuta",
        current_plan: "Nuvarande plan",
        current_year: "Innevarande år",
        custom_field: "Anpassat fält",
        custom_instructions: "Anpassade instruktioner",
        custom_url: "Anpassad URL",
        customer: "Kund",
        customer_name_convention: "Kundens namnkonvention",
        customer_reviews: "Recensioner",
        customers: "Kunder",
        customize: "Anpassa",
        customize_review_page: "Anpassa Recensionssida",
        daily: "Dagligen",
        daily_email_requests: "Dagliga e-postförfrågningar",
        daily_limit: "Daglig gräns",
        daily_requests: "Dagliga förfrågningar",
        daily_sms_requests: "Dagliga SMS förfrågningar",
        dark: "Mörk",
        dashboard: "Instrumentpanel",
        date: "Datum",
        date_added: "Datum tillagt",
        date_canceled: "Datum för avbokning",
        date_clicked: "Datum klickat",
        date_complained: "Datum för klagomål",
        date_delivered: "Leveransdatum",
        date_failed: "Datum misslyckades",
        date_messaged: "Datum meddelande",
        date_opened: "Datum öppnat",
        date_replied: "Svarsdatum",
        date_requested: "Datum begärt",
        date_reviewed: "Datum Recenserad",
        date_scheduled: "Schemalagt datum",
        date_sent: "Datum skickat",
        date_signed_up: "Datum anmäld",
        date_updated: "Datum uppdaterat",
        dates: "Datum",
        day: "Dag",
        days: "dagar",
        days_after_last_request: "dagar efter senaste förfrågan",
        days_later: "dagar senare",
        deactivate: "Avaktivera",
        default: "Standard",
        default_language: "Standardspråk",
        default_review_page: "Standard Recensionssida",
        default_review_visibility: "Standardsynlighet för Recension",
        default_tone: "Standardton",
        delay: "Dröjsmål",
        delete: "Radera",
        delete_1_customer: "Ta bort 1 kund",
        delete_1_review: "Ta bort 1 Recension",
        delete_1_review_page: "Ta bort 1 Recensionssida",
        delete_1_widget: "Ta bort 1 widget",
        delete_agency: "Ta bort byrå",
        delete_custom_field: "Ta bort anpassat fält",
        delete_customer: "Ta bort kund",
        delete_customers: "Ta bort kunder",
        delete_external_link: "Ta bort extern Länk",
        delete_field: "Ta bort fält",
        delete_link: "Ta bort Länk",
        delete_location: "Ta bort plats",
        delete_message: "Ta bort meddelande",
        delete_n_customers: "Ta bort {count} kunder",
        delete_n_review_pages: "Ta bort {count} Recensionssidor",
        delete_n_reviews: "Ta bort {count} Recensioner",
        delete_n_widgets: "Ta bort {count}-widgetar",
        delete_project: "Ta bort projekt",
        delete_qr_code: "Ta bort QR-kod",
        delete_reply: "Ta bort svar",
        delete_review: "Ta bort Recension",
        delete_review_page: "Ta bort Recensionssida",
        delete_review_pages: "Ta bort Recensionssidor",
        delete_reviews: "Ta bort Recensioner",
        delete_signature: "Ta bort Signatur",
        delete_source: "Ta bort källa",
        delete_space: "Ta bort arbetsyta",
        delete_tag: "Ta bort Tag",
        delete_tag_rule: "Ta bort taggregel",
        delete_template: "Ta bort mall",
        delete_user: "Ta bort användare",
        delete_webhook: "Ta bort webhook",
        delete_widget: "Ta bort widgeten",
        delete_widgets: "Ta bort widgetar",
        deleted: "Raderad",
        delivered: "Levereras",
        description: "Beskrivning",
        deselect_all: "Avmarkera alla",
        disable: "Inaktivera",
        disable_automatic_review_collection: "Inaktivera automatisk recensionsinsamling",
        disable_field: "Inaktivera fält",
        disable_when_links_are_visible: "Inaktivera när länkar är synliga",
        disabled: "Inaktiverad",
        disconnect: "Koppla från",
        disconnect_integration: "Koppla bort integrationen",
        discord_community: "Discord gemenskap",
        display_name: "Visningsnamn",
        dmarc: "DMARC",
        dmarc_status_for: "DMARC -status för",
        do_not_hide_from_public: "Göm inte från allmänheten",
        do_not_send: "Skicka inte",
        documentation: "Dokumentation",
        domain: "Domän",
        domain_name: "Domännamn",
        dont_have_an_account: "Har du inget konto?",
        dont_send_thanks: "Skicka inte tack",
        download: "Ladda ner",
        download_records: "Ladda ner poster",
        download_template: "Ladda ner mall",
        dpa: "DPA",
        dsar: "DSAR",
        duplicate: "Duplicera",
        duplicate_project: "Duplicera projekt",
        duplicate_review_page: "Duplicera Recensionssida",
        duplicate_reviews: "Dubbletter av Recensioner",
        duplicate_widget: "Duplicera widgeten",
        edit: "Redigera",
        edit_1_customer: "Redigera 1 kund",
        edit_1_review: "Redigera 1 Recension",
        edit_client: "Redigera Klient",
        edit_custom_field: "Redigera anpassat fält",
        edit_customer: "Redigera kund",
        edit_customers: "Redigera kunder",
        edit_field: "Redigera fält",
        edit_link: "Redigera Länk",
        edit_location: "Redigera plats",
        edit_member: "Redigera medlem",
        edit_n_customers: "Redigera {count} Kunder",
        edit_n_reviews: "Redigera {count} Recensioner",
        edit_notes: "Redigera anteckningar",
        edit_qr_code: "Redigera QR-kod",
        edit_reviews: "Redigera Recensioner",
        edit_signature: "Redigera Signatur",
        edit_source: "Redigera källa",
        edit_strategy: "Redigera strategi",
        edit_tag: "Redigera Tag",
        edit_tag_rule: "Redigera taggregel",
        edit_team_member: "Redigera teammedlem",
        edit_visibility: "Redigera synlighet",
        edit_webhook: "Redigera webhook",
        editable_ratings: "Redigerbara betyg",
        earned: "Förtjänade",
        eligible: "Berättigad",
        email: "E-post",
        email_address: "E-postadress",
        email_validation_invalid: "E-postvalidering misslyckades",
        email_validation_passed: "E-postvalidering godkänd",
        email_validation_unknown: "E-postadressen kunde inte verifieras",
        emails: "E-postmeddelanden",
        embed_code: "Bädda in kod",
        enable: "Aktivera",
        enable_automatic_review_collection: "Aktivera automatisk recensionsinsamling",
        enable_for_all_reviews: "Aktivera för alla recensioner",
        enable_for_positive_reviews: "Aktivera för positiva recensioner",
        enable_on_review_pages: "Aktivera på recensionssidor",
        enabled: "Aktiverad",
        end: "Avsluta",
        ends: "Slutar",
        exclude: "Utesluta",
        exclude_email: "Uteslut e-post",
        exclude_sms: "Uteslut SMS",
        excluded_channels: "Uteslutna kanaler",
        expand: "Expandera",
        expired: "Utgått",
        export: "Exportera",
        export_1_customer: "Exportera 1 kund",
        export_1_review: "Exportera 1 Recension",
        export_all: "Exportera alla",
        export_all_customers: "Exportera alla kunder",
        export_all_reviews: "Exportera alla Recensioner",
        export_customers: "Exportera kunder",
        export_n_customers: "Exportera {count} Kunder",
        export_n_reviews: "Exportera {count} Recensioner",
        export_reviews: "Exportera Recensioner",
        external_link: "Extern Länk",
        external_links: "Externa Länkar",
        extra_locations: "Extra platser",
        faces: "Ansikten",
        failed: "Misslyckades",
        feedback: "Feed-back",
        field: "Fält",
        fields: "Fält",
        filter: "Filtrera",
        first: "Första",
        first_charged: "Först debiterad",
        first_name: "Förnamn",
        first_name_last_initial: "Förnamn, efternamnsinitial",
        flag_as_duplicate: "Flagga som dubblett",
        font: "Font",
        font_family: "Typsnittsfamilj",
        font_size: "Fontstorlek",
        footer: "Sidfot",
        for: "För",
        forgot_password: "Glömt lösenord",
        form: "Form",
        free: "Gratis",
        free_requests_included: "Gratis förfrågningar ingår",
        from: "från",
        full_name: "Fullständigt namn",
        generate: "Generera",
        generate_meta: "Generera metadata",
        generate_qr_code: "Generera QR-kod",
        generate_reply: "Generera svar",
        generate_review: "Generera Recension",
        generating: "Genererar",
        get_started: "Kom igång",
        get_started_checklist: "Kom igång checklista",
        get_the_lifetime_deal: "Få Lifetime Deal",
        getting_started: "Komma igång",
        google_fonts: "Google Fonts",
        grouped_by_request: "Grupperad efter begäran",
        has_links: "Har Länkar",
        has_notes: "Har anteckningar",
        has_redirects: "Har omdirigeringar",
        have_an_account: "Har du ett konto?",
        header: "Rubrik",
        hidden: "Dold",
        hidden_from_search_engines: "Dold från sökmotorer",
        hidden_reviews: "Dolda Recensioner",
        hide: "Dölja",
        hide_all_reviews: "Dölj alla recensioner",
        hide_avatar: "Göm Avatar",
        hide_date: "Dölj datum",
        hide_drop_shadow: "Dölj skugga",
        hide_field_label: "Dölj fältetikett",
        hide_from_public: "Dölj från allmänheten",
        hide_name: "Dölj namn",
        hide_pagination: "Dölj paginering",
        highlight_color: "Markeringsfärg",
        host: "Värd",
        hours: "Timmar",
        icon: "Ikon",
        icon_size: "Ikonstorlek",
        icons: "Ikoner",
        id: "ID",
        image: "Bild",
        import: "Importera",
        import_address1: "Kundens adressrad 1.",
        import_address2: "Kundens adressrad 2.",
        import_city: "Kundens stad eller ort.",
        import_company: "Kundens företagsnamn.",
        import_created_at: "Datumet för recensionen.",
        import_customers: "Importera kunder",
        import_email: "Kundens e-postadress.",
        import_first_name: "Kundens förnamn.",
        import_from_boost_space: "Importera från Boost.space",
        import_from_facebook: "Importera från Facebook",
        import_from_google: "Importera från Google",
        import_from_hubspot: "Importera från HubSpot",
        import_from_make_com: "Importera från Make.com",
        import_from_pabbly: "Importera från Pabbly",
        import_from_stripe: "Importera från Stripe",
        import_from_zapier: "Importera från Zapier",
        import_last_name: "Kundens efternamn.",
        import_list: "Kommaseparerad lista över",
        import_notes: "Anteckningar endast för internt bruk.",
        import_phone: "Kundens telefonnummer.",
        import_postal_code: "Kundens postnummer.",
        import_recent_reviews: "Importera senaste Recensioner",
        import_review: "Recensionstexten.",
        import_reviews: "Importera Recensioner",
        import_score: "Betyget från 1-5.",
        import_signed_up_at: "Kundens startdatum.",
        import_slug: "slug eller UUID för en",
        import_state: "Kundens delstat eller region.",
        incentive: "Incitament",
        include: "Omfatta",
        include_sample_reviews: "Inkludera recensioner",
        incoming_webhook_url: "Inkommande Webhook URL",
        inherit: "Ärva",
        initializing: "Initierar",
        initials: "Initialer",
        insert_variable: "Infoga variabel",
        instructions: "Instruktioner",
        integration: "Integration",
        integrations: "Integrationer",
        interval: "Intervall",
        introduction: "Introduktion",
        invite: "Bjuda",
        invite_client: "Bjud in Klient",
        invite_failed: "Inbjudan misslyckades",
        invite_member: "Bjud in medlem",
        invite_sent_to: "Inbjudan skickad till",
        invite_team_member: "Bjud in teammedlem",
        invited: "Inbjudna",
        issuer_url: "Utgivarens URL",
        italic: "Kursiv",
        joined: "Anslöt sig",
        key: "Nyckel",
        keywords: "Nyckelord",
        keywords_in_replies: "Nyckelord i svar",
        keywords_in_reviews: "Nyckelord i Recensioner",
        kiosk_page: "Kiosksida",
        label: "Märka",
        label_font_size: "Etikett teckenstorlek",
        labels: "Etiketter",
        language: "Språk",
        languages: "Språk",
        large: "Stor",
        last_charged: "Senast debiterad",
        last_name: "Efternamn",
        layout: "Layout",
        leave: "Lämna",
        leave_project: "Lämna projektet",
        leave_space: "Lämna arbetsyta",
        left: "Vänster",
        let_clients_sign_in_with_sso: "Låt klienter logga in med SSO",
        less: "mindre",
        lifecycle_stage: "Livscykelstadiet",
        lifetime_deal: "Livstidsaffär",
        light: "Ljus",
        limit: "Begränsa",
        limits: "Gränser",
        link: "Länk",
        link_color: "Länkfärg",
        link_reveal_position: "Länk position",
        link_revealer_button: "Knapp för att visa Länk",
        link_revealer_label: "Etikett för länkvisning",
        link_revealer_rating: "Betyg för länkvisning",
        links: "Länkar",
        links_per_review_page: "Länkar per Recensionssida",
        list: "Lista",
        list_unsubscribe_headers: "Rubriker för List-Unsubscribe",
        load_more: "Ladda mer",
        loading: "Laddar",
        location: "Plats",
        location_address: "Plats Adress",
        location_name: "Platsnamn",
        location_picker: "Platsväljare",
        locations: "Platser",
        locations_limit: "Platsgräns",
        log_in: "Logga in",
        log_out: "Logga ut",
        logo: "Logotyp",
        logo_height: "Logotyp Höjd",
        long: "Lång",
        lowest_rating: "Lägsta betyg",
        ltd: "LTD",
        make_default: "Gör som standard",
        manage: "Hantera",
        manage_limits: "Hantera gränser",
        manage_overrides: "Hantera åsidosättningar",
        manage_payout_account: "Hantera utbetalningskonto",
        manage_subscription: "Hantera prenumeration",
        manual_entry: "Manuell inmatning",
        max: "Max",
        max_size: "Max storlek",
        maximum_characters: "Maximalt antal Tecken",
        maximum_customers: "Maximalt antal kunder",
        maximum_locations: "Maximalt antal platser",
        maximum_members: "Maximalt antal medlemmar",
        maximum_review_length: "Maximal recensionslängd",
        maximum_tags: "Maximalt Tags",
        maximum_widgets: "Maximalt antal widgetar",
        mcp: "MCP Server",
        mcp_server: "MCP Server",
        mcp_server_url: "MCP Server URL",
        medium: "Medium",
        member: "Medlem",
        members: "Medlemmar",
        menu: "Meny",
        message: "Meddelande",
        message_link_expiration: "Länk utgångsdatum",
        messaged: "Meddelade",
        messages: "Meddelanden",
        messages_clicked: "Meddelanden klickade",
        messages_sent: "Meddelanden skickade",
        messaging_service_sid: "Meddelandetjänst SID",
        min: "Min",
        min_size: "Min storlek",
        minimal_delay: "Minimal fördröjning",
        minimum_characters: "Minsta Tecken",
        minutes: "Minuter",
        month: "månad",
        monthly: "Månatlig",
        monthly_email_requests: "Månatliga e-postförfrågningar",
        monthly_limit: "Månadsgräns",
        monthly_pricing_only: "Endast månadspris",
        monthly_request_limit: "Månadsgräns för begäran",
        monthly_requests: "Månatliga förfrågningar",
        monthly_sms_requests: "Månatliga SMS förfrågningar",
        months: "Månader",
        months_free: "{count} Månader gratis",
        more: "mer",
        more_clients: "fler kunder",
        more_customers: "fler kunder",
        more_options: "Fler alternativ",
        more_patients: "fler patienter",
        more_reviews: "fler recensioner",
        more_reviews_needed: "Fler recensioner behövs för att sammanfatta",
        more_users: "fler användare",
        more_visitors: "fler besökare",
        move: "Flytta",
        moved: "Flyttad",
        name: "Namn",
        native_reviews: "Native Recensioner",
        negative_term: "Negativ term",
        negative_trends: "Negativa trender",
        new: "Ny",
        new_password: "Nytt lösenord",
        no: "Nej",
        no_available_options: "Inga tillgängliga alternativ",
        no_credit_card_required: "Inget kreditkort krävs",
        no_data_available: "Inga data tillgängliga",
        no_negative_trends: "Inga negativa trender ännu",
        no_positive_trends: "Inga positiva trender ännu",
        no_reminders: "Skicka inte påminnelser",
        no_retries: "Inga återförsök",
        no_review: "Ingen recension",
        none: "Ingen",
        not_connected: "Ej ansluten",
        not_reviewed: "Ej Recenserad",
        notes: "Anteckningar",
        notifications: "Aviseringar",
        now: "Nu",
        number_of_charges: "Antal avgifter",
        number_of_reminders: "Antal påminnelser",
        number_of_retries: "Antal återförsök",
        number_of_review_suggestions: "Antal recensionsförslag",
        of: "av",
        off: "Av",
        on: "På",
        on_channel: "på kanal {channel}.",
        opened: "Öppnad",
        options: "Alternativ",
        or_log_in_with_email: "eller logga in med din e-postadress",
        or_sign_up_with_email: "eller använd din e-postadress",
        our_reviews: "Våra Recensioner",
        output: "Utdata",
        page_footer: "Sidfot",
        paid: "Betald",
        paragraph: "Stycke",
        password: "Lösenord",
        past_month: "Senaste månaden",
        past_months: "Senaste {inc} månaderna",
        past_week: "Förra veckan",
        past_year: "Förra året",
        past_years: "Senaste {inc} åren",
        paused: "Pausad",
        payment_method: "Betalningsmetod",
        payout_status_completed: "Avslutad",
        payout_status_pending: "I avvaktan på",
        pending: "I avvaktan på",
        pending_deployment: "Väntar på distribution",
        pending_validation: "Väntar på validering",
        per_day: "per dag",
        per_month: "per månad",
        permissions: "Behörigheter",
        phone: "Telefon",
        phone_number: "Telefonnummer",
        pixels: "pixlar",
        placeholder: "Platshållare",
        placement: "Placering",
        plan: "Plan",
        plan_bullet1: "Ta bort vårt varumärke på e-postmeddelanden, sidor och widgets",
        plan_bullet2: "Använd din domän för kundvända sidor och e-postsändning",
        plan_bullet3: "Gör produkten till din med vit märkning för byråer",
        please_rate_our_service: "Vänligen betygsätt vår tjänst",
        png: "PNG",
        policies: "Policyer",
        popular: "Populär",
        port: "Port",
        position: "Placera",
        positive_only: "Endast positiva Recensioner",
        positive_term: "Positiv term",
        positive_trends: "Positiva trender",
        powered_by: "Drivs av",
        preview: "Förhandsvisning",
        preview_kiosk_page: "Förhandsgranska kiosksida",
        preview_review_page: "Förhandsgranska Recensionssida",
        price: "Pris",
        pricing: "Prissättning",
        primary_color: "Grundfärg",
        priority: "Prioritet",
        privacy_policy: "Sekretesspolicy",
        proceed_to_dashboard: "Fortsätt till instrumentpanelen",
        product: "Produkt",
        profile: "Profil",
        project: "Projekt",
        project_name: "Projektnamn",
        setup_ask_delay: "Hur länge man ska vänta innan man ber om en granskning",
        setup_reminders: "Hur många påminnelser att skicka",
        project_paused: "Det här projektet är pausat.",
        project_suspended: "Detta projekt är suspenderat.",
        project_website: "Projektets hemsida",
        projects: "Projekt",
        projects_limit: "Projektgräns",
        publish: "Publicera",
        publish_changes: "Publicera ändringarna på alla andra recensionssidor",
        published: "Publicerad",
        purchase: "Köpa",
        qr_code: "QR-kod",
        qr_code_name_placeholder: "Bord 1, Reception",
        qr_codes: "QR-koder",
        quantity: "Kvantitet",
        query: "Fråga",
        quick_import: "Snabb import",
        rating: "Betyg",
        rating_order: "Betygsordning",
        rating_out_of: "betyg ur",
        rating_save_all: "Spara betyg före varje recension",
        rating_save_customer: "Spara betyg innan en kundrecension",
        rating_save_never: "Spara aldrig betyg före recension",
        rating_selection: "Betygsval",
        rating_selector: "Betygsväljare",
        ratings: "Betyg",
        read: "Läsa",
        reapply_highlights_eligible: "Återskapa höjdpunkter med AI för alla positiva recensioner",
        reconnect: "Återanslut",
        redeem: "Återlösa",
        redirect_uri: "Omdirigerings-URI",
        redirects: "Omdirigeringar",
        refer_and_earn: "Referera och tjäna pengar",
        referral_billing_status_active: "Prenumererad",
        referral_billing_status_canceled: "Avbruten",
        referral_billing_status_trial: "Provperiod",
        referral_billing_status_trial_expired: "Testperioden har löpt ut",
        referral_billing_status_trial_expiring: "Testperioden löper ut",
        referral_program: "Villkor för hänvisningsprogrammet",
        referrals: "Referenser",
        refresh: "Uppdatera",
        regenerate: "Regenerera",
        reject_all: "Avvisa alla",
        related_reviews: "Liknande Recensioner",
        related_similarity: "Likhet",
        remaining: "Återstående",
        reminder: "Påminnelse",
        reminders: "Påminnelser",
        remove: "Ta bort",
        remove_client: "Ta bort Klient",
        remove_cname: "Ta bort CNAME",
        remove_domain: "Ta bort domän",
        remove_from_project: "Ta bort från projektet",
        remove_member: "Ta bort medlem",
        remove_smtp_configuration: "Ta bort SMTP -konfigurationen",
        remove_team_member: "Ta bort teammedlem",
        rename: "Döpa om",
        rename_template: "Byt namn på mall",
        renews: "Förnyar",
        replied: "svarade",
        reply: "Svar",
        reply_to: "Svara till",
        replying_on: "Svarar på",
        request: "Begäran",
        request_date: "Datum för begäran",
        request_review: "Begär en Recension",
        request_reviews: "Begär Recensioner",
        requested: "Begärde",
        requested_review: "Begärd Recension",
        requests: "Förfrågningar",
        requests_left_this_month: "förfrågningar kvar denna månad",
        requests_remaining: "Återstående förfrågningar",
        require_field: "Kräv fält",
        require_subscription: "Kunden måste ha ett aktivt abonnemang",
        required: "Nödvändig",
        reschedule_message: "Omplanera meddelande",
        resend_invite: "Skicka inbjudan igen",
        reset_password: "Återställ lösenord",
        restore: "Återställa",
        restore_to_defaults: "Återställ till standardinställningar",
        restore_widget: "Återställ widgeten",
        resubscribe: "Prenumerera igen",
        resubscribe_customer: "Prenumerera igen som kund",
        resync: "Synkronisera igen",
        resync_account: "Synkronisera konto igen",
        resync_now: "Synkronisera igen nu",
        retries: "Återförsök",
        reveal_above_form: "Avslöja formuläret ovan",
        reveal_after_submission: "Avslöja efter inlämning",
        reveal_below_form: "Avslöja formuläret nedan",
        review: "Recension",
        review_length: "Recensionslängd",
        review_link: "Recensionslänk",
        review_missed: "Recension missad",
        review_not_requested: "Recension begärs inte",
        review_origin: "Denna recension kom från mall",
        review_page: "Recensionssida",
        review_pages: "Recensionssidor",
        review_requested: "Recension begärd",
        review_spotlight: "Utvald recension",
        review_suggestion: "Recensionsförslag",
        review_suggestions: "Recensionsförslag",
        review_text: "Recensionstext",
        review_wall: "Recensionsvägg",
        reviewed: "Recenserad",
        reviews: "Recensioner",
        reviews_ask: "Be",
        reviews_query_failed: "Något gick fel. Försök igen.",
        reviews_query_placeholder: "Sök recensioner eller ställ en fråga...",
        reviews_with_highlights: "Recensioner med höjdpunkter",
        reviews_with_replies: "Recensioner med svar",
        reviews_without_replies: "Recensioner utan svar",
        revoke: "Återkalla",
        revoke_client: "Återkalla appen",
        roadmap: "Färdkarta",
        role: "Roll",
        sans_serif: "Sans Serif",
        save: "Spara",
        save_preferences: "Spara inställningar",
        save_template: "Spara mall",
        save_template_as_new: "Spara ny mall",
        saved: "Sparat",
        schedule: "Schema",
        schedule_review_request: "Schemalägg recensionsförfrågan",
        scheduled: "Schemalagt",
        score: "Poäng",
        search: "Söka",
        second: "Sekund",
        secret_key: "Hemlig nyckel",
        sections: "Avsnitt",
        security_code: "Säkerhetskod",
        select: "Välja",
        select_account: "Välj ett konto",
        select_all: "Välj Alla",
        select_an_option: "Välj ett alternativ",
        select_bulk_action: "Välj Bulk Action",
        select_csv_file: "Välj CSV fil",
        select_date: "Välj datum",
        select_field: "Välj ett fält",
        select_icon: "Välj en ikon",
        select_location: "Välj en plats",
        select_plan: "Välj en plan",
        select_review: "Välj en Recension",
        select_source: "Välj en källa",
        select_tag: "Välj en Tag",
        selected: "Vald",
        send: "Skicka",
        send_1_reminder: "Skicka 1 påminnelse",
        send_2_reminders: "Skicka 2 påminnelser",
        send_3_reminders: "Skicka 3 påminnelser",
        send_anytime: "Skicka när som helst",
        send_between: "Skicka mellan",
        send_message: "Skicka meddelande",
        send_retries: "Skicka {count} försök",
        send_retry: "Skicka {count} Försök igen",
        send_test: "Skicka ett test",
        send_thanks: "Skicka tack",
        sender_email_address: "Avsändarens e-postadress",
        sender_id: "Avsändar ID",
        sender_name: "Avsändarens namn",
        sending_domain: "Skickar domän",
        sent: "Skickat",
        sent_replies: "Skickade svar",
        serif: "Serif",
        settings: "Inställningar",
        share: "Dela",
        share_link: "Dela Länk",
        short: "Kort",
        show: "Visa",
        show_1_suggestion: "Visa ett förslag",
        show_100_results: "Visa 100 resultat",
        show_2_suggestions: "Visa två förslag",
        show_25_results: "Visa 25 resultat",
        show_3_suggestions: "Visa tre förslag",
        show_4_suggestions: "Visa fyra förslag",
        show_5_suggestions: "Visa fem förslag",
        show_50_results: "Visa 50 resultat",
        show_all_reviews: "Visa alla recensioner",
        show_arrows: "Visa pilar",
        show_avatar: "Visa Avatar",
        show_cookie_consent_banner: "Visa samtyckesbanner för cookies",
        show_date: "Visa datum",
        show_dots: "Visa prickar",
        show_drop_shadow: "Visa skugga",
        show_field: "Visa fält på följande betyg",
        show_full: "Visa hela stjärnor",
        show_photo: "Visa endast foto",
        show_positive_reviews: "Visa endast positiva recensioner",
        show_to_public: "Visa för allmänheten",
        showcase: "Showcase",
        showcase_page: "Utställningssida",
        sign_up: "Registrera dig",
        sign_up_for_free: "Registrera dig gratis",
        sign_up_with_email: "Registrera dig med e-post",
        sign_in_with_sso: "Logga in med SSO",
        sign_up_with_google: "Registrera dig med Google",
        signature: "Signatur",
        signatures: "Signaturer",
        signed_up: "Anmälda",
        since: "Sedan",
        size: "Storlek",
        skip: "Hoppa",
        slug: "Slug",
        small: "Små",
        sms: "SMS",
        smtp_configuration: "SMTP konfiguration",
        sort: "Sortera",
        source: "Källa",
        source_code: "Källkod",
        sources: "Källor",
        space: "Arbetsyta",
        space_name: "Namn på arbetsyta",
        spaces: "Arbetsytor",
        split: "Split",
        sso: "SSO",
        star_color: "Stjärnfärg",
        stars: "Stjärnor",
        start: "Start",
        start_free_trial: "Starta gratis provperiod",
        start_getting_more_reviews: "Börja få fler Recensioner",
        status: "Status",
        store_code: "Butikskod",
        strategy: "Strategi",
        sub_processors: "Underbiträden",
        subject: "Ämne",
        subscribe: "Prenumerera",
        subscription: "Prenumeration",
        success_page: "Framgångssida",
        suggestion: "Förslag",
        suggestions: "Förslag",
        summary: "Sammanfattning",
        support: "Support",
        suspend: "Suspendera",
        suspend_project: "Pausa projektet",
        suspended: "Suspenderad",
        svg: "SVG",
        switch_to_smtp_setup: "Växla till SMTP inställning",
        switch_to_standard_setup: "Växla till standardinställningar",
        symbol: "Symbol",
        sync: "Synkronisera",
        sync_account: "Synkronisera konto",
        sync_now: "Synkronisera nu",
        sync_scheduled_time: "Synkronisering schemalagd {time}",
        synced_time: "Synkroniserad {time}",
        system: "System",
        system_fonts: "Systemteckensnitt",
        tag: "Tag",
        tag_1_customer: "Tag 1-kund",
        tag_1_review: "Tag 1 Recension",
        tag_customers: "Tagga kunder",
        tag_existing_reviews: "Tag befintliga Recensioner",
        tag_n_customers: "Tag {count} Kunder",
        tag_n_reviews: "Tag {count} Recensioner",
        tag_reviews: "Tagga recensioner",
        tag_rule: "Taggregel",
        tag_with_ai: "Tagga med AI",
        tags: "Tags",
        tags_for_customers: "Tags för kunder",
        tags_for_reviews: "Tags för Recensioner",
        team: "Team",
        team_member: "Teammedlem",
        team_members: "Teammedlemmar",
        template: "Mall",
        templates: "Mallar",
        terms_of_service: "Användarvillkor",
        test_template: "Testmall",
        tests: "Tester",
        text: "Text",
        text_alignment: "Textjustering",
        text_color: "Text färg",
        thank_you_messages: "Tackmeddelanden",
        thanks: "Tack",
        theme: "Tema",
        third: "Tredje",
        time_zone: "Tidszon",
        timeframe: "Tidsram",
        title: "Titel",
        tone: "Ton",
        top: "Överst",
        top_left: "Överst till vänster",
        top_right: "Överst till höger",
        total_charges: "Totala avgifter",
        total_reviews: "Totalt Recensioner",
        trigger: "Utlösare",
        trigger_charged: "Skicka begäran efter en debitering",
        trigger_created: "Skicka förfrågan efter registrering",
        try_free: "Prova gratis",
        try_it_free: "Prova gratis",
        type: "Typ",
        types: "Typer",
        unarchive: "Avarkivera",
        unarchive_customer: "Avarkivera kund",
        underline: "Betona",
        unflag_as_duplicate: "Avflagga som dubblett",
        unknown: "Okänd",
        unnamed: "Namnlös",
        unpublish: "Avpublicera",
        unpublished: "Opublicerad",
        unreplied: "Obesvarad",
        unsent_messages: "Ej skickade meddelanden",
        unsubscribe: "Avsluta prenumerationen",
        unsubscribe_customer: "Avsluta prenumeration Kund",
        unsubscribe_customers: "Avsluta prenumerationer Kunder",
        unsubscribe_text: "Avsluta prenumeration Text",
        unsubscribed: "Avslutad prenumeration",
        unsuspend: "Återaktivera",
        unsuspend_project: "Återuppta projekt",
        unverified: "Ej verifierad",
        update: "Uppdatera",
        update_password: "Uppdatera lösenord",
        update_plan: "Uppdatera plan",
        update_share_template: "Uppdatera mall",
        updated: "Uppdaterad",
        updates: "Uppdateringar",
        upgrade: "Uppgradera",
        upgrade_for_more: "Uppgradera för mer",
        upgrade_to_use: "Uppgradera för att använda den här funktionen",
        upload: "Ladda upp",
        upload_csv: "Ladda upp CSV",
        upload_icon: "Ladda upp en ikon",
        url: "URL",
        use: "Använda",
        use_filters_for_aggregate: "Använd filter för aggregering",
        user: "Användare",
        user_id: "Användar ID",
        user_info: "Användarinformation",
        username: "Användarnamn",
        utc: "UTC",
        validate: "Bekräfta",
        validate_customer_email: "Validera kundens e-postadress",
        validation: "Godkännande",
        validations: "Valideringar",
        value: "Värde",
        verify: "Kontrollera",
        verify_email_address: "Verifiera e-postadress",
        view: "Visa",
        view_all: "Visa alla",
        view_all_features: "Visa alla funktioner",
        view_available_fields: "Visa tillgängliga fält",
        view_documentation: "Visa dokumentation",
        view_email_templates: "Visa e-postmallar",
        view_review_pages: "Visa Recensionssidor",
        view_reviews: "Visa Recensioner",
        view_settings: "Visa inställningar",
        view_setup_guide: "Visa installationsguide",
        view_showcase: "Visa presentation",
        view_strategy: "Visa strategi",
        visibility: "Synlighet",
        visible: "Synlig",
        visible_reviews: "Synliga Recensioner",
        visible_to_search_engines: "Synlig för sökmotorer",
        wait_between_reminders: "Vänta mellan påminnelserna",
        wait_period: "Vänteperiod",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Webbplats",
        weekly: "Varje vecka",
        weeks: "Veckor",
        widget: "Widget",
        widgets: "Widgets",
        with_ai: "med AI",
        worst_to_best: "Sämst till bäst",
        write: "Skriva",
        written_reviews: "Skriftliga Recensioner",
        year: "år",
        yearly: "Årlig",
        yes: "Ja",
        your_referral_link: "Din hänvisningslänk"
    },
    landing: {
        announcement: "Få ryktesrapporter med vår MCP-server",
        callout_1_subtitle: "Få tillgång till alla kärnfunktioner i 7 dagar gratis. Inget kreditkort krävs. Börja få fler recensioner nu.",
        callout_1_title: "Gratis provperiod",
        callout_2_subtitle: "Importera kunder med Stripe, HubSpot, Zapier, CSV -uppladdning, e-post BCC, API och mer.",
        callout_2_title: "Snabb installation",
        callout_3_subtitle: "Du bestämmer vem du vill skicka till och när. Vi skickar recensionsförfrågningar till dina kunder varje dag.",
        callout_3_title: "Automatisk",
        callout_4_subtitle: "Samla in negativ feedback innan du ber kunder att lämna offentliga recensioner.",
        callout_4_title: "Feedbackrouting",
        counter: "Gå med i fler än 5 000 lokala tjänsteföretag",
        feature_1_subtitle: "Be dina kunder automatiskt om recensioner – inget extra arbete behövs.",
        feature_1_title: "Förbättra ditt rykte",
        feature_2_subtitle: "Lägg enkelt till dina befintliga tredjepartsrecensioner.",
        feature_2_title: "Importera dina Recensioner",
        feature_3_subtitle: "Visa enkelt recensioner på din webbplats med helt anpassningsbara widgetar.",
        feature_3_title: "Visa upp Recensioner var som helst",
        feature_4_subtitle: "Anpassa dina e-post- och SMS -förfrågningar och påminnelser så att de matchar ditt varumärke.",
        feature_4_title: "Anpassningsbara mallar",
        feature_5_subtitle: "Ställ in det en gång och låt oss hantera när recensionsförfrågningar och påminnelser skickas.",
        feature_5_title: "Smart förfrågningsschemaläggning",
        feature_6_subtitle: "Samla in recensioner från tredje part eller privat feedback – allt på din egen anpassade sida.",
        feature_6_title: "Personlig Recensionssida",
        feature_7_subtitle: "Gör det enklare för kunder att lämna bra recensioner med AI-drivna recensionsförslag.",
        feature_7_title: "AI-recensionsförslag",
        feature_8_subtitle: "Omdirigera kunder till alla dina recensionssajter från en enda länk eller QR-kod.",
        feature_8_title: "Samla Recensioner överallt",
        industries: {
            accountants: "Redovisningskonsulter",
            auto_repair: "Bilverkstäder",
            chiropractors: "Kiropraktorer",
            cleaning: "Städtjänster",
            contractors: "Entreprenörer",
            dentists: "Tandläkare",
            doctors: "Läkare",
            electricians: "Elektriker",
            financial_advisors: "Finansiella rådgivare",
            hvac: "VVS",
            insurance_brokers: "Försäkringsmäklare",
            landscapers: "Trädgårdsmästare",
            law_firms: "Advokatbyråer",
            locksmiths: "Låssmeder",
            mortgage_brokers: "Bolånerådgivare",
            optometrists: "Optiker",
            pest_control: "Skadedjursbekämpning",
            personal_trainers: "Personliga tränare",
            physical_therapists: "Sjukgymnaster",
            plumbers: "Rörmokare",
            real_estate: "Fastigheter",
            restaurants: "Restauranger",
            salons: "Salonger",
            self_storage: "Self storage",
            spas: "Spa",
            tour_guides: "Turistguider",
            veterinarians: "Veterinärer"
        },
        industries_title: "Recensionshantering för lokala tjänsteföretag",
        subtitle: "Begär recensioner på autopilot. Få fler 5-stjärniga betyg. Rank högre än dina konkurrenter.",
        title: "AI-rykteshantering för att",
        title_phrases: {
            google_reviews: "få fler Google-recensioner",
            autopilot: "be om recensioner automatiskt",
            suggested_by_chatgpt: "bli föreslagen av ChatGPT"
        },
        title_contact: "Hur kan vi hjälpa till?",
        title_faq: "Vanliga frågor",
        title_features: "Allt-i-ett-verktyget för att begära och visa upp recensioner.",
        title_footer: "Sluta jaga recensioner. Börja få dem.",
        title_integrations: "Integrationer",
        title_ltd: "Betala en gång och använd för alltid med vårt begränsade livstidserbjudande.",
        title_pricing: "Alla funktioner. Enkel prissättning.",
        title_reviews: "Se varför vi är rankade som #1 inom recensionshantering"
    },
    plans: {
        agency: {
            agency_api: "Byråns API",
            branded_portal: "Varumärkesbaserad klientportal",
            client_invites: "Klient , roller och åsidosättningar",
            custom_domain: "Anpassad byrådomän",
            everything_in_business: "Allt i affärsplanen",
            locations_included: "5 platser inkluderade",
            review_requests: "5 000 granskningsförfrågningar \/ plats \/ månad",
            sso: "Enkel inloggning (SSO)",
            support: "Dedikerad kundsupport",
            volume_pricing: "Volympriser från 49 USD\/mån"
        },
        business: {
            ai: "AI-svar, insikter och Fråga AI",
            api_mcp: "API och MCP Server",
            custom_domains: "Anpassad e-post och domäner för recensionssidor",
            google_facebook: "Google Företagsprofil och Facebook",
            locations_included: "1 plats ingår",
            review_requests: "{count} granskningsförfrågningar \/ plats \/ månad",
            support: "Dedikerad kundsupport",
            unlimited_customers: "Obegränsade kunder",
            volume_pricing: "Volympriser från 99 USD\/mån"
        },
        selectors: {
            agency_included: "{count} Platser inkluderade",
            agency_tier: "+{from}–{to} platser · ___V2__\/{month} vardera",
            agency_tier_plus: "+{from}+ platser · {price}\/{month} vardera",
            business_tier: "{from}–{to} platser · {price}\/{month} vardera",
            business_tier_plus: "{from}+ platser · {price}\/{month} vardera"
        }
    },
    pricing: {
        faq_business_vs_agency_a: "Business är för företag som hanterar sitt eget rykte – prissatt per plats, med månatlig eller årlig fakturering. Agency är för byråer och konsulter som behöver en white-label-kundportal, anpassad byrådomän, kund-SSO, kundinbjudningar och åsidosättningar per projekt. Agency är endast månadsvis och inkluderar 5 platser till att börja med.",
        faq_business_vs_agency_q: "Vad är skillnaden mellan företag och byrå?",
        feature_sso_tooltip: "Låt inbjudna kunder logga in på din portal med sin företagsidentitetsleverantör via OpenID Connect (till exempel Auth0, Okta eller Azure AD)."
    },
    mcp_example_prompts: {
        labels: {
            add_customer_and_ask: "Lägg till en kund och begär en recension",
            customers_to_ask: "Hitta kunder att be om recensioner",
            location_leaderboard: "Jämför platsprestanda",
            outreach_health: "Granska leveranskvaliteten för förfrågningar",
            review_digest: "Veckovis recensionssammanfattning",
            send_review_requests: "Skicka recensionsförfrågningar i bulk"
        },
        texts: {
            add_customer_and_ask: "Lägg till en ny kund med hjälp av kontaktuppgifterna jag ger dig och schemalägg sedan en recensionsförfrågan för dem via e-post med två påminnelser.",
            customers_to_ask: "Lista upp till 50 kunder som aldrig har blivit ombedda att skriva en recension, sorterade efter registreringsdatum med den nyaste först. Hoppa över alla som avslutat prenumerationen. Inkludera namn, e-postadress och registreringsdatum.",
            location_leaderboard: "Skapa en 90-dagars topplista efter plats med recensionsantal, genomsnittligt betyg, procentandel 5-stjärnor och trend jämfört med de föregående 90 dagarna. Sortera efter betyg och flagga alla minskningar över 0,2 stjärnor.",
            outreach_health: "För e-postmeddelanden som skickats under de senaste 14 dagarna, rapportera totalt antal skickade meddelanden, leveransfrekvens, öppningsfrekvens, klickfrekvens och felfrekvens. Flagga eventuella avvikelser.",
            review_digest: "Sammanfatta alla recensioner från de senaste 7 dagarna. Inkludera antal, genomsnittligt betyg, uppdelning efter källa och plats, de 3 viktigaste teman och de 3 viktigaste problemen.",
            send_review_requests: "För kunder som registrerat sig under de senaste 30 dagarna och inte har blivit tillfrågade, schemalägg en recensionsförfrågan via e-post med två påminnelser. Visa listan först och vänta på min bekräftelse."
        }
    },
    messages: {
        activated: "Aktiverades.",
        archived: "Har arkiverats.",
        canceled: "Avbröts framgångsrikt.",
        cannot_copy: "Det går inte att kopiera till urklipp",
        cname_active: "CNAME status är aktiv.",
        cname_not_active: "CNAME statusen är ännu inte aktiv.",
        connected: "Ansluten framgångsrikt.",
        cookie_banner_text: "Vi använder cookies för att förbättra din upplevelse. Du kan anpassa dina inställningar eller acceptera alla.",
        cookie_category_analytics_desc: "Används för att mäta webbplatstrafik och produktanvändning. Dessa cookies hjälper oss att förstå hur besökare använder vår webbplats.",
        cookie_category_essential_desc: "Alltid aktiva. Dessa cookies krävs för att webbplatsen ska fungera och kan inte stängas av.",
        cookie_category_functional_desc: "Aktivera förbättrade funktioner som livechatt. Dessa cookies spårar dig inte i reklamsyfte.",
        cookie_category_marketing_desc: "Används för annonsering och kampanjmätning. Dessa kan inkludera annonspixlar och attributionsverktyg.",
        copied: "Kopierades framgångsrikt.",
        created: "Framgångsrikt skapat.",
        deactivated: "Inaktiverad.",
        deleted: "Raderad.",
        disconnected: "Anslutningen lyckades.",
        duplicated: "Duplicerades framgångsrikt.",
        error: "Något gick fel. Försök igen.",
        google_connect_failed: "Vi kunde inte ansluta till Google. Du kan försöka igen eller hoppa över det för tillfället.",
        oauth_consent_intro: "{client} begär åtkomst till ditt konto.",
        oauth_request_missing: "OAuth-auktoriseringsbegäran saknas eller har löpt ut.",
        operation_connection_sync_failed: "{integration_name} synkroniseringen misslyckades.",
        operation_connection_sync_progress: "Synkroniserar {integration_name}…",
        operation_connection_sync_success: "{integration_name} synkronisering klar.",
        operation_customer_import_failed: "Kund misslyckades.",
        operation_customer_import_progress: "Importerar kunder…",
        operation_customer_import_success: "Kund är klar.",
        operation_review_import_failed: "Importen av Recension misslyckades.",
        operation_review_import_progress: "Importerar recensioner…",
        operation_review_import_success: "Recension är klar.",
        operation_review_scrape_failed: "Importen av den senaste recensionen misslyckades.",
        operation_review_scrape_progress: "Importerar senaste recensioner…",
        operation_review_scrape_success: "Import av senaste granskning har slutförts.",
        processed: "Bearbetades.",
        published: "Publicerad.",
        purchased: "Framgångsrikt köpt.",
        queued: "Planerat.",
        refreshed: "Uppdaterades framgångsrikt.",
        removed: "Har tagits bort.",
        resubscribed: "Återprenumererades.",
        revoked: "Återkallad.",
        saved: "sparat framgångsrikt.",
        scheduled: "Planerat.",
        sent: "Skickat.",
        started: "Började framgångsrikt.",
        stopped: "Stoppade framgångsrikt.",
        sso_failed: "Det gick inte att auktorisera med SSO.",
        sso_invalid_callback: "Ogiltig SSO-återanrop.",
        sso_not_configured: "SSO är inte konfigurerad.",
        sso_openid_config_failed: "Det gick inte att läsa in OpenID-konfigurationen.",
        sso_token_exchange_failed: "Det gick inte att slutföra SSO-tokenutbytet.",
        subscribed: "Prenumererade framgångsrikt.",
        suspended: "Avstängd framgångsrikt.",
        synced: "Synkroniserad.",
        unarchived: "Har tagits bort från arkivet.",
        unpublished: "Lyckades avpublicera.",
        unscheduled: "Oschemalagd framgångsrikt.",
        unsubscribed: "Prenumerationen har avslutats.",
        unsuspended: "Avstängningen har återupptagits.",
        updated: "Uppdaterades framgångsrikt.",
        upgraded: "Uppgraderad.",
        validated: "Validerad.",
        verified: "Verifierad."
    },
    notices: {
        agency: "Driv en byrå? Du kan vitmärka vår produkt så att dina kunder bara ser ditt varumärke när de använder tjänsten.",
        connected_apps: "Appar som du ansluter via MCP visas här.",
        connector: "Importera dina kunder från tusentals applikationer med {brand}.",
        customer_messages: "Begär en recension för att schemalägga meddelanden.",
        customer_reviews: "Begär en recension från denna kund.",
        customers: "Importera dina kunder för att börja begära recensioner.",
        external_links: "Lägg till externa länkar till din kundportal för att hjälpa dig sälja dina tjänster. Dessa länkar kommer att visas för dina kunder i sidofältet.",
        links: "Lägg till knappar på din sida för att lämna recensioner på tredje parts webbplatser.",
        locations: "Skapa en plats så att du kan tillskriva recensioner till flera platser.",
        ltd: "Lås upp livstidsåtkomst med din åtkomstkod. Varje kod kommer med ett begränsat antal månatliga förfrågningar, plus alla funktioner. Koder är staplingsbara. 3 koder tar bort alla våra varumärken och låser upp byråfunktioner. Ange din åtkomstkod nedan.",
        mcp_example_prompts: "När MCP server är ansluten, klistra in dessa i din assistent som en utgångspunkt.",
        messages: "Varje förfrågan och påminnelse kommer att visas här när recensioner efterfrågas från dina kunder.",
        no_commissions: "Du har inte tjänat några provisioner än.",
        no_payouts: "Utbetalningar skickas manuellt när ditt godkända saldo når minst 50,00 USD och ditt bankkonto är anslutet.",
        no_projects: "Du har inte tilldelats ett projekt ännu. Kontakta din administratör för att få åtkomst.",
        no_referrals: "Du har inte rekommenderat någon än. Dela din hänvisningslänk för att komma igång.",
        qr_codes: "Skapa QR-koder med anpassade färger, platser och tags. Ladda ner som SVG eller PNG.",
        referrals_share_subject: "Min AI-rykteshanterare",
        referrals_share_text: "Mitt hemliga vapen för att få recensioner: More Good Reviews. AI-rykteshantering som faktiskt fungerar. Registrera dig med min länk:",
        review_pages: "Ditt projekt kan ha flera recensionssidor där dina kunder kan lämna recensioner. Detta är användbart för företag med mer än en plats.",
        reviews: "Vi väntar på recensioner från era kunder.",
        showcase: "Vi har precis börjat.",
        signatures: "Skapa en e-postsignatur att kopiera och klistra in i ditt e-postprogram.",
        sources: "Skapa en källa så att du kan kategorisera dina recensioner.",
        tag_rules: "Skapa en regel för att kategorisera dina recensioner automatiskt med AI.",
        tags: "Skapa en tag för att kategorisera dina recensioner och kunder.",
        unauthorized: "Du har inte behörighet att komma åt den här sidan.",
        unsubscribed: "Du har nu avslutat prenumerationen på recensionsförfrågningar.",
        webhooks: "Lägg till webhooks för att få aviseringar om plattformshändelser.",
        widgets: "Skapa widgets för att bädda in recensioner på din webbplats.",
        your_referral_link_text: "Dela din länk för att tjäna {rate}% återkommande provision på varje betalning från kunder du hänvisar. Utbetalningar skickas manuellt när ditt godkända saldo når minst 50,00 USD."
    },
    notification_types: {
        descriptions: {
            imports: "Skickas när importen är klar",
            new_reviews: "Skickas när recensioner tas emot",
            sent_replies: "Skickas när recensioner besvaras automatiskt",
            weekly_reports: "En sammanfattning av aktiviteten skickas varje vecka"
        },
        names: {
            imports: "Import",
            new_reviews: "Nya Recensioner",
            sent_replies: "Skickade svar",
            weekly_reports: "Veckovisa rapporter"
        }
    },
    roles: {
        manager: "Chef",
        operator: "Operatör",
        owner: "Ägare",
        super_admin: "Administratör",
        viewer: "Läsare"
    },
    tasks: {
        automate: "Turn on automatic review requests and reminders. Each customer is contacted once, and can unsubscribe anytime.",
        customers: "Import customers with names and email or phone — manually, via Stripe, HubSpot, app connectors, the API, or by BCC’ing your project email on invoices.",
        google: "Connect Google Business Profile to import reviews, keep them in sync, and reply from here.",
        review_page: "Customize the page that captures reviews and can send customers to third-party sites — text, layout, fields, links, and redirects.",
        strategy: "Choose when customers are asked for reviews. We’ve set a simple default you can change anytime.",
        templates: "Edit the request and reminder emails customers receive. Both include one-click ratings, plus your logo and branding."
    },
    titles: {
        accept_invite: "Acceptera inbjudan",
        accepting_invite: "Accepterar inbjudan",
        access_denied: "Åtkomst nekad",
        account: "Konto",
        actions: "Åtgärder",
        add_custom_field: "Lägg till anpassat fält",
        add_ons: "Tillägg",
        address: "Adress",
        agency: "Byrå",
        ai_assistant: "AI-assistent",
        ai_highlights: "AI-höjdpunkter",
        ai_replies: "AI svarar",
        ai_review_suggestions: "AI-recensionsförslag",
        analytics: "Analys",
        api: "API",
        api_key: "API nyckel",
        appearance: "Utseende",
        application_connectors: "Applikationskopplingar",
        attributes: "Attribut",
        authorize: "Godkänna",
        auto_tagging: "Automatisk märkning",
        automatic_review_collection: "Automatisk recensionsinsamling",
        billing: "Fakturering",
        branding: "Branding",
        change_password: "Ändra lösenord",
        clients: "Klienter",
        cname: "CNAME",
        conditions: "Villkor",
        connected_apps: "Anslutna appar",
        contact_us: "Kontakta oss",
        cookie_policy: "Cookiepolicy",
        cookie_preferences: "Cookie-inställningar",
        copy: "Kopiera",
        create_your_account: "Skapa ditt konto",
        crms: "CRMs",
        css: "CSS",
        custom_field: "Anpassat fält",
        custom_fields: "Anpassade fält",
        custom_icons: "Anpassade ikoner",
        customer: "Kund",
        customer_facing_pages: "Kundvända sidor",
        customers: "Kunder",
        dashboard: "Instrumentpanel",
        details: "Detaljer",
        dmarc: "DMARC",
        domain: "Domän",
        dpa: "Avtal om databehandling",
        dsar: "Begäran om åtkomst till data",
        email_address: "E-postadress",
        email_messages: "E-postmeddelanden",
        email_settings: "E-postinställningar",
        email_usage: "E-postanvändning",
        emails: "E-postmeddelanden",
        embed_code: "Bädda in kod",
        examples: "Exempel",
        export: "Exportera",
        external_link: "Extern Länk",
        external_link_num: "Extern Länk #{num}",
        external_links: "Externa Länkar",
        field: "Fält",
        fields: "Fält",
        filters: "Filter",
        form_fields: "Formulärfält",
        got_access_code: "Har du en åtkomstkod?",
        how_it_works: "Hur det fungerar",
        incentive: "Incitament",
        instructions: "Instruktioner",
        integration: "Integration",
        integrations: "Integrationer",
        javascript: "JavaScript",
        latest_reviews: "Senaste Recensioner",
        lifetime_deal: "Livstidsaffär",
        limits: "Gränser",
        link: "Länk",
        links: "Länkar",
        location: "Plats",
        location_picker: "Platsväljare",
        locations: "Platser",
        log_in: "Logga in",
        log_out: "Logga ut",
        make_default: "Gör som standard",
        manage_limits: "Hantera gränser",
        manage_overrides: "Hantera åsidosättningar",
        manage_review: "Hantera Recension",
        mcp_example_prompts: "Exempel på uppmaningar",
        mcp_server: "MCP Server",
        message: "Meddelande",
        messages: "Meddelanden",
        meta: "Meta",
        no_clients: "Inga klienter",
        no_commissions: "Inga provisioner",
        no_connected_apps: "Inga anslutna appar",
        no_custom_fields: "Inga anpassade fält",
        no_customers: "Inga kunder",
        no_links: "Inga Länkar",
        no_locations: "Inga platser",
        no_members: "Inga medlemmar",
        no_messages: "Inga meddelanden",
        no_payouts: "Inga utbetalningar",
        no_projects: "Inga projekt",
        no_qr_codes: "Inga QR-koder",
        no_referrals: "Inga hänvisningar",
        no_review_pages: "Inga Recensionssidor",
        no_reviews: "Inga Recensioner",
        no_tags: "Inga Tags",
        no_team_members: "Inga teammedlemmar",
        no_template: "Ingen mall",
        no_widgets: "Inga widgetar",
        notifications: "Aviseringar",
        options: "Alternativ",
        overview: "Översikt",
        payment_method: "Betalningsmetod",
        photo: "Bild",
        plans: "Planer",
        powered_by: "Drivs av",
        pricing: "Prissättning",
        privacy_policy: "Sekretesspolicy",
        profile: "Profil",
        project: "Projekt",
        project_limits: "Projektgränser",
        project_overrides: "Projektöverskridanden",
        projects: "Projekt",
        qr_code: "QR-kod",
        qr_codes: "QR-koder",
        ratings: "Betyg",
        redeem_access_code: "Lös in åtkomstkod",
        redirecting: "Omdirigerar",
        redirects: "Omdirigeringar",
        referrals_commissions: "Provisioner",
        referrals_payouts: "Utbetalningar",
        referral_program: "Villkor för hänvisningsprogrammet",
        reminders: "Påminnelser",
        reply: "Svar",
        request: "Begäran",
        request_options: "Begär alternativ",
        requests: "Förfrågningar",
        required: "Nödvändig",
        reschedule_message: "Omplanera meddelande",
        reset_password: "Återställ lösenord",
        retries: "Återförsök",
        review: "Recension",
        review_link: "Recensionslänk",
        review_page: "Recensionssida",
        review_pages: "Recensionssidor",
        review_spotlight: "Utvald recension",
        review_suggestions: "Recensionsförslag",
        review_wall: "Recensionsvägg",
        reviewer: "Recensent",
        reviews: "Recensioner",
        save_changes: "Spara ändringar",
        schedule: "Schema",
        scrape_a_website: "Skrapa en webbplats",
        search_engines: "Sökmotorer",
        sections: "Avsnitt",
        select_csv_file: "Välj CSV -fil",
        select_project: "Välj ett projekt",
        selecting_project: "Att välja projekt",
        sending_domain: "Skickar domän",
        sending_limits: "Sändningsgränser",
        settings: "Inställningar",
        setup: "Inställning",
        setup_basics: "Din Begäran",
        setup_business: "Kom igång",
        setup_google: "Din Google -företagsprofil",
        setup_trusted: "Betrott av fler än 5 000 företag",
        showcase: "Showcase",
        sign_up: "Registrera dig",
        signature: "Signatur",
        signatures: "Signaturer",
        signing_in: "Loggar in",
        single_sign_on: "Enkel inloggning",
        slug: "Slug",
        sms: "SMS",
        sms_messages: "SMS meddelanden",
        sms_usage: "SMS användning",
        smtp_configuration: "SMTP konfiguration",
        source: "Källa",
        sources: "Källor",
        space: "Arbetsyta",
        spaces: "Arbetsytor",
        stats: "Statistik",
        sub_processors: "Underbiträden",
        success_page: "Framgångssida",
        summary: "Sammanfattning",
        tag: "Tag",
        tag_rule: "Taggregel",
        tags: "Tags",
        team_members: "Teammedlemmar",
        template: "Mall",
        templates: "Mallar",
        terms_of_service: "Användarvillkor",
        two_factor_authentication: "Tvåfaktorsautentisering",
        unable_to_complete_request: "Det gick inte att slutföra begäran",
        unique_review_link: "Unik recensionslänk",
        unsent_messages: "Ej skickade meddelanden",
        unsubscribe: "Avsluta prenumeration",
        update_plan: "Uppdatera plan",
        usage: "Användande",
        user: "Användare",
        user_info: "Användarinformation",
        verify_email_address: "Verifiera e-postadress",
        verifying_email: "Verifierar e-post",
        visibility: "Synlighet",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Webbplats",
        white_label_api: "White Label API",
        white_label_client_portal: "White Label-klientportal",
        white_label_image_urls: "Webbadresser för White Label-bilder",
        white_label_sending_domain: "White Label Skickar domän",
        white_label_widget_tag: "White Label Widget Tag",
        widget: "Widget",
        widget_num: "Widget #{num}",
        widgets: "Widgets",
        your_plan: "Din plan"
    },
    tones: {
        apologetic: "Ursäktande",
        casual: "Tillfällig",
        empathetic: "Empatisk",
        enthusiastic: "Entusiastisk",
        formal: "Formell",
        friendly: "Vänlig",
        grateful: "Tacksam",
        humorous: "Humoristisk",
        informative: "Informativ"
    },
    widgets: {
        labels: {
            alignment: "Inriktning",
            animation: "Animation",
            autoplay: "Autouppspelning",
            autoplay_delay: "Fördröjning för automatisk uppspelning",
            avatar: "Avatar",
            background_color: "Bakgrundsfärg",
            border: "Kant",
            border_color: "Kantfärg",
            border_radius: "Gränsradie",
            border_width: "Kantbredd",
            carousel: "Karusell",
            colors: "Färger",
            company: "Företag",
            customer: "Kund",
            customer_position: "Kundposition",
            date: "Datum",
            delay: "Dröjsmål",
            drop_shadow: "Skugga",
            duration: "Varaktighet",
            filters: "Filter",
            font: "Font",
            font_emphasis: "Teckensnittsbetoning",
            font_family: "Typsnittsfamilj",
            font_size: "Fontstorlek",
            include_hidden: "Inkludera dolda Recensioner",
            layout: "Layout",
            limit: "Recensioner per sida",
            location_ids: "Platser",
            marquee: "Marquee",
            max_slides: "Max Slides",
            max_width: "Max bredd",
            name_convention: "Namn",
            padding: "Inre marginal",
            pagination: "Paginering",
            quotes: "Citat",
            rating: "Betyg",
            rating_round: "Avrundning",
            rating_round_hundredth: "Närmaste hundradel (4,94)",
            rating_round_tenth: "Närmaste tiondel (4,9)",
            review: "Recension",
            review_chars: "Recensionslängd",
            review_count: "Antal recensioner",
            review_id: "Recension",
            review_ids: "Recensioner",
            review_ids_for_faces: "Recensioner för Faces",
            reviews: "Recensioner",
            schema: "Schema",
            schema_name: "Företagsnamn",
            schema_type: "Företagstyp",
            score: "Lägsta betyg",
            show_on_mobile: "Visa på mobilen",
            slider: "Slider",
            source: "Källa",
            source_ids: "Källor",
            source_position: "Källposition",
            speed: "Hastighet",
            star_color: "Stjärnfärg",
            star_display: "Stjärndisplay",
            star_size: "Stjärnstorlek",
            star_spacing: "Star Spacing",
            star_style: "Star Style",
            star_style_classic: "Classic",
            star_style_sharp: "Sharp",
            tag_ids: "Tags",
            take: "Maximalt antal Recensioner",
            text_color: "Text färg",
            truncate: "Förkorta Recension",
            visible_slides: "Synliga bilder",
            width: "Bredd"
        },
        types: {
            badge: "Emblem",
            carousel: "Karusell",
            carousel_dynamic: "Dynamisk karusell",
            corner: "Hörn",
            corner_dynamic: "Dynamiskt hörn",
            faces: "Ansikten",
            headline: "Rubrik",
            highlights: "Höjdpunkter",
            marquee: "Marquee",
            spotlight: "Utvald",
            wall: "Vägg"
        }
    }
}